import { Button } from '../core'
import { LoadingDots } from '../core/LoadingDots'
import { styled } from '../styles/styled'

type PropTypes = {
  isLoading: boolean
  textColor: string
  label: string
  onClick(): void
}

const StyledLink = styled('a')<{ textColor: string }>(({ theme, textColor }) => {
  return {
    '&:link, &:visited, &:hover, &:active': {
      color: textColor,
      margin: 15,
    },
  }
})

const TransactionActionLink = ({ isLoading, textColor, label, onClick }: PropTypes) => {
  const handleClick = (e) => {
    e.preventDefault()
    onClick()
  }
  return (
    <p>
      <Button href="#" color="primary" variant="text" onClick={handleClick}>
        {isLoading ? <LoadingDots color="#a2a2a2" /> : label}
      </Button>
    </p>
  )
}

export default TransactionActionLink
